import { Box, Stack } from "@mui/material";
import { Custom, Field, Workflow } from "components";
import { useApp, useTheme } from "contexts";
import { useWorkflow } from "contexts/components";
import { IMenu } from "interfaces";
import { forwardRef } from "react";
import { createStep } from "utils/helpers";

const StepDetails = forwardRef(() => {
  const { t } = useApp();
  const { theme } = useTheme();
  const { updateData, data } = useWorkflow<Workflow.Utils.ContributorType>(); // Get updateData from context

  return (
    <>
      <Custom.Typography size={theme.font.md} weight={theme.font.bold}>
        {data.potluck.party_name}
      </Custom.Typography>

      <Box mt={theme.spacing.md}>
        <Stack direction="row" spacing={theme.spacing.sm}>
          <Custom.Typography size={theme.font.xs} weight={theme.font.bold}>
            {t.component.workflow.contributor.menu_theme}:
          </Custom.Typography>
          <Custom.Typography
            size={theme.font.xs}
            color={theme.color.font.accent}
          >
            {data.potluck.theme}
          </Custom.Typography>
        </Stack>
      </Box>

      <Box mt={theme.spacing.md}>
        <Stack direction="row" spacing={theme.spacing.sm}>
          <Custom.Typography
            component="pre"
            size={theme.font.xs}
            sx={{ whiteSpace: "pre-wrap" }}
          >
            {t.component.workflow.contributor.headline}
          </Custom.Typography>
        </Stack>
      </Box>

      <Box mt={theme.spacing.md}>
        <Field.Menu.Contribute
          createdBy={data.potluck.created_by._id}
          menu={data.potluck.menu}
          onUpdate={(menu: IMenu[]) => updateData("potluck.menu", menu)}
        />
      </Box>
    </>
  );
});

export default createStep<Workflow.Utils.ContributorType>(StepDetails);
